export const WIDA_RESET_SPRING_YEAR = 2026;

export interface DashboardGateInputs {
  cutScoresFinal: boolean;
  accessAdministrationSpringYears: number[];
  sisFieldsMapped: boolean;
}

export function comparablePostResetYearCount(springYears: number[]): number {
  const postReset = springYears.filter((year) => year >= WIDA_RESET_SPRING_YEAR);
  return new Set(postReset).size;
}

export function isGateASatisfied(inputs: DashboardGateInputs): boolean {
  return inputs.cutScoresFinal;
}

export function isGateBSatisfied(inputs: DashboardGateInputs): boolean {
  return comparablePostResetYearCount(inputs.accessAdministrationSpringYears) >= 2;
}

export function isGateCSatisfied(inputs: DashboardGateInputs): boolean {
  return inputs.sisFieldsMapped;
}
